// Ums/umsRouter.js
import React, { lazy, Suspense } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

const UserData = lazy(() => import('Ums/pages/users/userData'))
// const Settings = lazy(() => import("Ums/pages/settings"));
// const Profile = lazy(() => import("Ums/pages/profile"));

const UmsRouter = () => {
  const { path } = useRouteMatch()

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        <Route exact path={`${path}/users`} component={UserData} />
        {/* <Route exact path={`${path}/`} component={UmsDashboard} /> */}
        {/* <Route exact path={`${path}/settings`} component={Settings} /> */}
        {/* <Route exact path={`${path}/profile`} component={Profile} /> */}
      </Switch>
    </Suspense>
  )
}

export default UmsRouter
